export default __webpack_public_path__ + "static/media/LGTv.5531a905.png";